// 基金产品数据类型定义
export interface FundMetric {
  label: string;
  key: string;
  value: string;
  suffix?: string;
  prefix?: string;
  color?: string;
}

export interface FundProduct {
  name: string;
  code: string;
  key: string;
  metrics: FundMetric[];
}

export interface FundCategoryData {
  title: string;
  suggestRatio: string; 
  fundProducts: FundProduct[];
}

export interface FundData {
  [key: string]: FundCategoryData;
}

// 模拟接口数据
export const mockFundData: FundData = {
  cash: {
    title: '现金管理',
    suggestRatio: '25%',
    fundProducts: [
      {
        name: '华夏现金增利货币A',
        code: '003003',
        key: 'recommend_cash_name1',
        metrics: [
          {
            label: '近一年净值增长',
            key: 'recommend_cash_percent1',
            value: '2.35',
            suffix: '%',
            prefix: '+',
            color: '#F5222D'
          },
          {
            label: '七日年化',
            key: 'recommend_cash_return1',
            value: '2.41',
            suffix: '%',
            prefix: '+',
            color: '#1F1F1F'
          },
          {
            label: '规模',
            key: '',
            value: '345.6',
            suffix: '亿',
            prefix: '',
            color: '#1F1F1F'
          }
        ]
      },
      {
        name: '华夏现金增利货币A',
        code: '003003',
        key: 'recommend_cash_name2',
        metrics: [
          {
            label: '近一年净值增长',
            key: 'recommend_cash_percent2',
            value: '2.35',
            suffix: '%',
            prefix: '+',
            color: '#F5222D'
          },
          {
            label: '七日年化',
            key: 'recommend_cash_return2',
            value: '2.41',
            suffix: '%',
            prefix: '+',
            color: '#1F1F1F'
          },
          {
            label: '规模',
            key: '',
            value: '345.6',
            suffix: '亿',
            prefix: '',
            color: '#1F1F1F'
          }
        ]
      }
    ]
  },
  conservative: {
    title: '稳健收益',
    suggestRatio: '40%', 
    fundProducts: [
      {
        name: '南方宝元债券A',
        code: '003003',
        key: 'recommend_stable_name1',
        metrics: [
          {
            label: '近一年净值增长',
            key: 'recommend_stable_percent1',
            value: '5.76',
            suffix: '%',
            prefix: '+',
            color: '#F5222D'
          },
          {
            label: '最大回撤',
            key: 'recommend_stable_return1',
            value: '2.41',
            suffix: '%',
            prefix: '-',
            color: '#1F1F1F'
          },
          {
            label: '规模',
            key: '',
            value: '345.6',
            suffix: '亿',
            prefix: '',
            color: '#1F1F1F'
          }
        ]
      },
      {
        name: '南方宝元债券A',
        code: '003003',
        key: 'recommend_stable_name2',
        metrics: [
          {
            label: '近一年净值增长',
            key: 'recommend_stable_percent2',
            value: '5.76',
            suffix: '%',
            prefix: '+',
            color: '#F5222D'
          },
          {
            label: '最大回撤',
            key: 'recommend_stable_return2',
            value: '2.41',
            suffix: '%',
            prefix: '-',
            color: '#1F1F1F'
          },
          {
            label: '规模',
            key: '',
            value: '345.6',
            suffix: '亿',
            prefix: '',
            color: '#1F1F1F'
          }
        ]
      }
    ]
  },
  aggressive: {
    title: '进取收益',
    suggestRatio: '35%', 
    fundProducts: [
      {
        name: '南方宝元债券A',
        code: '003003',
        key: 'recommend_aggressive_name1',
        metrics: [
          {
            label: '近一年净值增长',
            key: 'recommend_aggressive_percent1',
            value: '5.76',
            suffix: '%',
            prefix: '+',
            color: '#F5222D'
          },
          {
            label: '最大回撤',
            key: 'recommend_aggressive_return1',
            value: '2.41',
            suffix: '%',
            prefix: '-',
            color: '#1F1F1F'
          },
          {
            label: '规模',
            key: '',
            // key: 'recommend_aggressive_percent1',
            value: '345.6',
            suffix: '亿',
            prefix: '',
            color: '#1F1F1F'
          }
        ]
      },
      {
        name: '南方宝元债券A',
        code: '003003',
        key: 'recommend_aggressive_name2',
        metrics: [
          {
            label: '近一年净值增长',
            key: 'recommend_aggressive_percent2',
            value: '5.76',
            suffix: '%',
            prefix: '+',
            color: '#F5222D'
          },
          {
            label: '最大回撤',
            key: 'recommend_aggressive_return2',
            value: '2.41',
            suffix: '%',
            prefix: '-',
            color: '#1F1F1F'
          },
          {
            label: '规模',
            key: '',
            value: '345.6',
            suffix: '亿',
            prefix: '',
            color: '#1F1F1F'
          }
        ]
      }
    ]
  }
};

 
 

 

 
